import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1rem',
    marginTop: '-0.75rem',

    '& h1': {
      fontFamily: 'Sora',
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: '2rem',
      color: '#000000',
      marginLeft: '-0.25rem',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
}))

export { useStyles }
